<template>
    <div>
        <div id="company_name">
            <span> {{company.name}}</span>
            <md-button class="md-icon-button" @click="lockUnlock">
                <md-icon v-if="roleAdmin">{{company.freeze?'lock':'lock_open'}}</md-icon>
            </md-button>
        </div>
        <div id="company_desc">
            您的公司总共授权设备{{company.auth_number}}台，现已经激活设备{{ authedAccount }}台，尚未激活{{ company.auth_number - authedAccount
            }}台，剩余授权数{{ company.auth_number - usedAccount }}，已冻结设备数{{ freezeCount }}
        </div>

        <div class="md-layout md-alignment-center-right">
            <div class="md-layout-item md-size-15">
                <md-field>
                    <label>授权名称</label>
                    <md-input v-model="newAuthName" placeholder="输入授权名称"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10">
                <md-field>
                    <label>授权数量</label>
                    <md-input v-model="newAuthNameNumber" type="number" placeholder="输入授权数量"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10" id="add_new">
                <md-button class="md-raised md-primary md-dense" @click="addAuthName(newAuthName, newAuthNameNumber)">
                    新增授权名称
                </md-button>
            </div>
        </div>

        <div class="md-layout md-alignment-center-right">
            <div class="md-layout-item md-size-15">
                <md-field md-clearable>
                    <label>设备序列号</label>
                    <md-input v-model="anonymousSn" placeholder="输入设备序列号"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10">
                <md-field>
                    <label>备注</label>
                    <md-input v-model="anonymousRemarks" placeholder="输入备注"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10">
                <md-button class="md-raised md-primary md-dense"
                           @click="addDevice(null, anonymousSn, anonymousRemarks)">
                    新增设备序列号
                </md-button>
            </div>
        </div>

        <div class="md-layout md-alignment-center-right">
            <md-button class="md-dense md-raised md-primary" @click="authNumberDialog = true" v-if="roleAdmin">增加总授权数
            </md-button>
            <md-button class="md-dense md-raised md-primary" @click="showAuthedDevices(null)">查询所有序列号</md-button>
        </div>
        <div>
            <md-table>
                <md-table-row>
                    <md-table-head class="table_head">序号</md-table-head>
                    <md-table-head class="table_head">授权名称</md-table-head>
                    <md-table-head class="table_head">授权数量</md-table-head>
                    <md-table-head class="table_head">激活数量</md-table-head>
                    <md-table-head class="table_head">操作</md-table-head>
                </md-table-row>

                <md-table-row
                        v-for="(item, index) in devices"
                        v-bind:key="item.device_name">
                    <md-table-cell>{{ index + 1 }}</md-table-cell>
                    <md-table-cell>{{ item.device_name }}</md-table-cell>
                    <md-table-cell>{{ item.auth_number }}</md-table-cell>
                    <md-table-cell>{{ item.active_count }}</md-table-cell>
                    <md-table-cell>
                        <md-button class="md-primary" @click="showModify(item.device_name, item.auth_number)">
                          修改授权数
                        </md-button>
                        <md-button class="md-primary" @click="showWakeupModify(item.device_name)">
                          唤醒设置
                        </md-button>
                        <md-button class="md-primary" @click="showAuthedDevices(item.device_name)">查询所有</md-button>
                        <md-button class="md-accent" @click="lockUnlockName(item.device_name, !item.freeze)">
                            {{item.freeze?'已冻结':'正常'}}
                        </md-button>
                    </md-table-cell>
                </md-table-row>

            </md-table>

        </div>

        <md-dialog :md-active.sync="modifyNameDialog">
            <md-dialog-title>修改授权数</md-dialog-title>
            <div class="content_input">
                <md-field>
                    <label>授权名称</label>
                    <md-input v-model="authNameModify" readonly></md-input>
                </md-field>
                <md-field>
                    <label>授权数量</label>
                    <md-input v-model="authNameNumberModify" type="number"></md-input>
                </md-field>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary md-raised" @click="modifyNameDialog = false">关闭</md-button>
                <md-button class="md-accent md-raised" @click="modifyAuthName(authNameModify, authNameNumberModify)">
                    修改
                </md-button>
            </md-dialog-actions>
        </md-dialog>

        <WakeupSettings ref="wakeupSettingsComponent"/>

        <md-dialog :md-active.sync="newDeviceDialog">
            <md-dialog-title>新增设备</md-dialog-title>
            <div class="content_input">
                <md-field>
                    <label>设备名称</label>
                    <md-input v-model="newDeviceName" readonly></md-input>
                </md-field>
                <md-field>
                    <label>设备序列号</label>
                    <md-input v-model="newDeviceSn"></md-input>
                </md-field>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary md-raised" @click="newDeviceDialog = false">关闭</md-button>
                <md-button class="md-accent md-raised" @click="addDevice(newDeviceName, newDeviceSn)">添加
                </md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog-prompt
                :md-active.sync="authNumberDialog"
                v-model="newAddAuthNumber"
                md-title="输入需要增加的授权设备数"
                md-cancel-text="取消"
                md-confirm-text="新增"
                @md-confirm="modifyAuthCount"/>

        <md-dialog-confirm
                :md-active.sync="dialogConfirm"
                md-title="确定要移除此名称吗？"
                md-content=""
                md-confirm-text="移除"
                md-cancel-text="取消"
                @md-cancel="onCancel"
                @md-confirm="onConfirm"/>

        <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
    </div>
</template>

<script>
    import WakeupSettings from "@/components/company/WakeupSettings";
    export default {
        name: "AuthNameManager",
      components: {WakeupSettings},
      data: () => ({
            devices: {},
            company: {},
            toast: false,
            toastMsg: "",
            authedAccount: 0,
            usedAccount: 0,
            freezeCount: 0,
            modifyNameDialog: false,
            newAuthName: "",
            authNameModify: "",
            newAuthNameNumber: '',
            authNameNumberModify: 0,
            dialogConfirm: false,
            delName: '',
            newDeviceName: '',
            newDeviceSn: '',
            newDeviceDialog: false,
            authNumberDialog: false,
            newAddAuthNumber: 0,
            anonymousSn: '',
            anonymousRemarks: '',
            roleAdmin: false,
        }),
        mounted() {
            let userInfo = JSON.parse(localStorage.getItem('user_info'));
            this.roleAdmin = userInfo.role === 1;
            this.getCompanyDetail();
            this.getAuthNames();
        },
        methods: {
            getAuthNames: function () {
                this.$http.get('/api/device/name/' + this.$route.params.company_id + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.devices = data.data.names;
                                this.authedAccount = data.data.authed_count;
                                this.freezeCount = data.data.freeze_count;
                                this.usedAccount = 0;
                                this.devices.forEach(device=> {
                                    this.usedAccount += device.auth_number;
                                });
                                this.usedAccount = this.usedAccount +  data.data.no_name_count;
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            addAuthName: function (name, count) {
                if (!this.newAuthName) {
                    this.showErrorTips('请输入授权名称');
                    return
                }
                if (!this.newAuthNameNumber) {
                    this.showErrorTips('请输入授权数量');
                    return
                }
                this.$http.post('/api/device/name/' + this.$route.params.company_id + '/' + name + '/' + count + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('添加成功');
                                this.newAuthName = '';
                                this.newAuthNameNumber = '';
                                this.getAuthNames();
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    case 5000:
                                        this.showErrorTips('未知错误（5000）');
                                        break;
                                    case 7000:
                                        this.showErrorTips('授权名称已存在（7000）');
                                        break;
                                    case 7100:
                                        this.showErrorTips('名称授权数超过总授权数（7100）');
                                        break;
                                    default:
                                        this.showErrorTips('添加失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            deleteNameQuery: function (name) {
                this.delName = name;
                this.dialogConfirm = true;
            },
            removeAuthName: function (name) {
                this.$http.delete('/api/device/name/' + this.$route.params.company_id + '/' + name + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('删除成功');
                                this.getAuthNames();
                            } else {
                                this.showErrorTips('删除失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            showModify: function (name, count) {
                this.authNameModify = name;
                this.authNameNumberModify = count;
                this.modifyNameDialog = true;
            },
            showWakeupModify: function (name) {
              this.$refs.wakeupSettingsComponent.companyId = this.$route.params.company_id;
              this.$refs.wakeupSettingsComponent.deviceName4Wakeup = name;
              this.$refs.wakeupSettingsComponent.modifyWakeupDialog = true;
              this.$refs.wakeupSettingsComponent.obtainSettings();
            },
            modifyAuthName: function (name, count) {
                this.modifyNameDialog = false;
                this.$http.put('/api/device/name/' + this.$route.params.company_id + '/' + name + '/' + count + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('修改成功');
                                this.getAuthNames();
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    case 5000:
                                        this.showErrorTips('未知错误（5000）');
                                        break;
                                    case 7100:
                                        this.showErrorTips('可用授权数超过总授权数（7100）');
                                        break;
                                    case 7200:
                                        this.showErrorTips('授权数不能小于已激活设备数（7200）');
                                        break;
                                    default:
                                        this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            getCompanyDetail() {
                this.$http.get('/api/company/detail/' + this.$route.params.company_id + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.company = data.data;
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            onConfirm() {
                if (this.delName) {
                    this.removeAuthName(this.delName);
                }
            },
            onCancel() {
            },
            modifyAuthCount: function () {
                if (!this.newAddAuthNumber) {
                    this.showErrorTips('需要输入数量');
                    return
                }
                let total = parseInt(this.newAddAuthNumber) + parseInt(this.company.auth_number);
                this.$http.put('/api/company/' + this.$route.params.company_id + '/auth/' + total + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('修改成功');
                                this.newAddAuthNumber = '';
                                this.getCompanyDetail();
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    case 4600:
                                        this.showErrorTips('不能小于已激活数（4600）');
                                        break;
                                    default:
                                        this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            showNewDeviceDialog: function (name) {
                this.newDeviceName = name;
                this.newDeviceDialog = true;
            },
            addDevice: function (newName, newSn, remarks) {
                newSn = newSn.trim();
                this.newDeviceDialog = false;
                if (!newSn) {
                    this.showErrorTips('请输入设备序列号');
                    return
                }
                let reg_name = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/;
                if (!reg_name.test(newSn)) {
                    this.showErrorTips('格式不正确');
                    return;
                }
                let url;
                if (newName) {
                    url = '/api/device/' + this.$route.params.company_id + '/' + newSn + '/' + newName + '/?remarks=' + remarks;
                } else {
                    url = '/api/device/' + this.$route.params.company_id + '/' + newSn + '/?remarks=' + remarks;
                }
                this.$http.post(url).then(
                    response => {
                        this.newDeviceName = '';
                        this.newDeviceSn = '';
                        this.anonymousSn = '';
                        this.anonymousRemarks = '';
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('设备添加成功');
                                this.getAuthNames();
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    case 5000:
                                        this.showErrorTips('未知错误（5000）');
                                        break;
                                    case 6000:
                                        this.showErrorTips('该设备已存在（6000）');
                                        break;
                                    case 8000:
                                        this.showErrorTips('无更多可用授权数（8000）');
                                        break;
                                    default:
                                        this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.newDeviceName = '';
                    this.newDeviceSn = '';
                    this.showErrorTips('未知错误' + error);
                })
            },
            showAuthedDevices: function (authName) {
                if (authName) {
                    this.$router.push('/dashboard/device-list/' + this.company.id + "?name=" + authName)
                } else {
                    this.$router.push('/dashboard/device-list/' + this.company.id)
                }
            },
            lockUnlock: function () {
                let url;
                if (this.company.freeze) {
                    url = '/api/company/unfreeze/'
                } else {
                    url = '/api/company/freeze/'
                }
                this.$http.put(url + this.company.id + "/").then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.company.freeze = !this.company.freeze;
                        } else {
                            this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                        }
                    } else {
                        this.showErrorTips('修改失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            lockUnlockName: function (name, freeze) {
                this.$http.post('/api/device/name/freeze/' + this.company.id + "/" + name + '/' + freeze + '/').then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.getAuthNames();
                        } else {
                            this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                        }
                    } else {
                        this.showErrorTips('修改失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
        }
    }
</script>

<style scoped>
    .table_head {
        text-align: center;
    }

    #company_name {
        font-size: 20px;
        color: black;
    }

    span {
        vertical-align: bottom;
    }

    #company_desc {
        text-align: left;
    }

    .content_input {
        padding: 0 20px;
    }

    .md-layout-item {
        padding: 0 10px;
    }
</style>